/* istanbul ignore file */
export * from './SearchScrollTopButton';
